import { View } from 'react-native';
import { useLivePowerSyncQuery } from '~/powersync/hooks/useLivePowerSyncQuery';
import { db } from '@/lib/local-api';
import type { WorkoutSupersetRecord } from '~/powersync/generated/schema';
import { WorkoutSuperset } from '~/workout/components/workout-superset/WorkoutSuperset';

export interface WorkoutStructureProps {
  /**
   * The workout ID to fetch supersets for
   */
  workoutId: string;
  /**
   * Whether the component is in loading state
   */
  isLoading?: boolean;
}

export const WorkoutStructure = ({
  workoutId,
  isLoading = false,
}: WorkoutStructureProps) => {
  // Fetch all supersets for this workout using clean local-api
  const { data: supersets, isLoading: isLoadingSupersets } =
    useLivePowerSyncQuery<WorkoutSupersetRecord>(
      db.Workout.queries.findSupersetsWithExercises(workoutId),
      [workoutId],
    );

  const isComponentLoading = isLoading || isLoadingSupersets;

  // Don't render anything if no supersets
  if (!supersets || supersets.length === 0) {
    return null;
  }

  return (
    <View>
      {supersets.map((superset) => (
        <WorkoutSuperset
          key={superset.id}
          superset={superset}
          isLoading={isComponentLoading}
        />
      ))}
    </View>
  );
};
